import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 85,
  label: "IPC大类年度申请趋势分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "shortIpc", label: "IPC大类", limit: 10, needTotal: true }],
    colDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "IPC大类年度申请趋势分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
